import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IncludeDetailsCheckboxesComponent } from './include-details-checkboxes.component';

@NgModule({
  declarations: [IncludeDetailsCheckboxesComponent],
  imports: [
    CommonModule
  ],
  exports: [IncludeDetailsCheckboxesComponent],
  entryComponents: [IncludeDetailsCheckboxesComponent],
})
export class IncludeDetailsCheckboxesModule { }
